import { render } from "./legoAccordionItem.vue?vue&type=template&id=02eb5af3&scoped=true"
import script from "./legoAccordionItem.vue?vue&type=script&lang=js"
export * from "./legoAccordionItem.vue?vue&type=script&lang=js"

import "./legoAccordionItem.vue?vue&type=style&index=0&id=02eb5af3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02eb5af3"],['__file',"src/components/lego/extend/legoAccordionItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02eb5af3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02eb5af3', __exports__)) {
    api.reload('02eb5af3', __exports__)
  }
  
  module.hot.accept("./legoAccordionItem.vue?vue&type=template&id=02eb5af3&scoped=true", () => {
    api.rerender('02eb5af3', render)
  })

}


export default __exports__